import { graphql } from '@shared/types/storefront'

graphql(/* GraphQL */ `
  fragment BreadcrumbItem on Collection {
    id
    title
    handle
  }

  fragment Breadcrumb on Metafield {
    id
    references(first: 5) {
      nodes {
        ... on Collection {
          ...BreadcrumbItem
        }
      }
    }
  }

  fragment Collection on Collection {
    id
    title
    description
    handle
    seo {
      description
      title
    }
    breadcrumb: metafield(key: "breadcrumb", namespace: "custom") {
      ...Breadcrumb
    }
    excludedFilters: metafield(key: "excluded_filters", namespace: "custom") {
      ...ExcludedFilters
    }
    excludedMarkets: metafield(key: "excluded_markets", namespace: "custom") {
      ...ExcludedMarkets
    }
    styleBadge: metafield(key: "style_badge", namespace: "custom") {
      ...StyleBadge
    }
    productDetailFeatures: metafield(
      key: "product_detail_features"
      namespace: "custom"
    ) {
      ...ProductDetailFeatures
    }
    productModelDetails: metafield(
      key: "product_model_details"
      namespace: "product"
    ) {
      ...ProductModelDetails
    }
    sizeInformation: metafield(key: "size_information", namespace: "custom") {
      ...SizeInformation
    }
    metafields(
      identifiers: [
        { namespace: "contentful", key: "content_before_listing" }
        { namespace: "contentful", key: "content_after_listing" }
        { namespace: "contentful", key: "content_inbetween_listing" }
        { namespace: "contentful", key: "hero" }
        { namespace: "flow", key: "hreflang" }
        { namespace: "custom", key: "breadcrumb" }
        { namespace: "custom", key: "robots" }
        { namespace: "custom", key: "hide_collection" }
        { namespace: "custom", key: "excluded_markets" }
        { namespace: "custom", key: "excluded_filters" }
        { namespace: "custom", key: "style_badge" }
        { namespace: "custom", key: "product_detail_features" }
        { namespace: "product", key: "user_manual" }
      ]
    ) {
      ...Metafield
    }
  }

  fragment CollectionProducts on ProductConnection {
    filters {
      ...Filter
    }
    items: nodes {
      ...ProductWithVariants
    }
    pageInfo {
      ...PageInfo
    }
  }

  fragment CollectionWithProductsPrev on Collection {
    ...Collection
    products(first: $ipp, after: $cursor, filters: $filter, sortKey: $sortKey) {
      ...CollectionProducts
    }
    baseFilterProducts: products(
      first: $ipp
      after: $cursor
      sortKey: $sortKey
    ) {
      filters {
        ...Filter
      }
    }
  }

  fragment CollectionWithProductsNext on Collection {
    ...Collection
    products(last: $ipp, before: $cursor, filters: $filter, sortKey: $sortKey) {
      ...CollectionProducts
    }
    baseFilterProducts: products(
      last: $ipp
      before: $cursor
      sortKey: $sortKey
    ) {
      filters {
        ...Filter
      }
    }
  }
`)

export const forwardCollectionQuery = graphql(/* GraphQL */ `
  query forwardCollection(
    $handle: String!
    $country: CountryCode
    $language: LanguageCode
    $filter: [ProductFilter!]
    $ipp: Int
    $sortKey: ProductCollectionSortKeys
    $cursor: String
  ) @inContext(country: $country, language: $language) {
    collection(handle: $handle) {
      ...CollectionWithProductsPrev
    }
  }
`)

export const backwardCollectionQuery = graphql(/* GraphQL */ `
  query backwardCollection(
    $handle: String!
    $country: CountryCode
    $language: LanguageCode
    $filter: [ProductFilter!]
    $ipp: Int
    $sortKey: ProductCollectionSortKeys
    $cursor: String
  ) @inContext(country: $country, language: $language) {
    collection(handle: $handle) {
      ...CollectionWithProductsNext
    }
  }
`)
